import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, View } from 'react-native';

import { assets } from '@assets';
import { loadingPageTestIDs } from '@constants';

import { useLoading } from './hooks';
import { styles } from './styles';

import { RadialGradientBackground } from '../../components/loading/RadialGradientBackground';
import { TWCPage } from '../../components/primitives/TWCPage/TWCPage';
import { TWCText } from '../../components/primitives/TWCText/TWCText';

export const LoadingPage = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'loadingPage',
  });

  const loadingPercent = useLoading();

  return (
    <TWCPage childIds={[]} pageID={loadingPageTestIDs.loadingPage}>
      <RadialGradientBackground>
        <View style={styles.wrapper}>
          <Image resizeMode={'contain'} source={assets.sunnyDayWhite} style={styles.sunImage} />
          <TWCText testID={loadingPageTestIDs.loadingText} variant={'regularText36Transparent'}>
            {`${t('loadingText')} ${loadingPercent}%`}
          </TWCText>
        </View>
      </RadialGradientBackground>
    </TWCPage>
  );
};
